import Vue                                  from "vue";
import { mapGetters }                       from "vuex";
import { EntitlementsService }              from "@/services/";
import { formatDateTime, stringHelper }     from "@/components/mixins";
import { LoadingSpinner }                   from "@/components";
import JsBarcode                            from "jsbarcode";

export default Vue.extend({
    name: "CompleteCoreCreditRequest",
    components: {
        LoadingSpinner
    },
    mixins: [formatDateTime, stringHelper],
    created() {
        window.scroll(0,0)
        this.getCcr()
    },
    updated(){
        this.groupedEntitlements.forEach( group => {
            // CCR Number barcodes
            JsBarcode(`.ccrBarcode`, `${this.ccr.Number}T0Z0100001`, {
                format: "CODE39",
                width: 2,
                height: 30,
                displayValue: false 
            })

            group.forEach( item => {
                // Item specific barcodes
                JsBarcode(`.itemBarcode${item.Id}`, item.Entitlement.OemPartCode,{
                    format: "CODE39",
                    width: 2,
                    height: 30,
                    displayValue: false
                })  
            })
        })
    },
    props: {
        ccrNumber: String,
        accountId: String,
        estimatedShipDate: String
    },
    computed: {
        ...mapGetters([
            "user",
            "getContentItem",
            "getRecentComponentData"
        ]),
    },
    data: () => ({
        ccr: {},
        groupedEntitlements: {},
        dealerCode: Number,
        isLoading: false,
        displayBarcodeValue: false,
    }),
    methods: {
        getCcr(){
            this.isLoading = true
            let requestParams = {
                AccountId: this.accountId.toString(),
                CcrNumber: this.ccrNumber,
                SearchEnd: this.estimatedShipDate,
                OpenCcrsOnly: true,
                PriorDaysToSearch: 400,
                OrderByField: "ModifiedDate",
                OrderByDirection: "DESC",
                PageNumber: 1,
                PageSize: 1
               } 
                
               EntitlementsService.GetCoreCreditRequests(requestParams)
               .then(response => {
                   this.ccr = response.data[0].Ccr
                   this.setGroupedEntitlements();
                   this.dealerCode = response.data[0].DealerCode
               })
               .finally(() => {
                    this.isLoading = false
               })
        },
        setGroupedEntitlements(){           
            let warrantyItems = _.filter(this.ccr.Items, {'Type': 'Warranty'})
            let groupedByType = _.groupBy(warrantyItems, 'Type')

            let returnItems = _.filter(this.ccr.Items, {'Type': 'Return'} )
            let groupedByPicCode = _.groupBy(returnItems, function(x){
                return x.Entitlement.PicCode.Code
            } )

            let groupedAndMerged = _.merge(groupedByType, groupedByPicCode)            
            this.groupedEntitlements = Object.entries(groupedAndMerged).map(x => 
                [...x[1]].sort((a, b) => 
                    a.Entitlement.OemPartCode.localeCompare(b.Entitlement.OemPartCode, undefined, { numeric: true, sensitivity: "base" })
                )
            )
        },
        downloadCcrPdf(){
            window.print()
        },
        getCommodityName(ccrGroup){                        
            return ccrGroup[0].Type === "Warranty" ? "Warranty" : ccrGroup[0].Entitlement.Description
        },
        getApproxWeight(ccrGroup){          
            let weights = ccrGroup.map(item => {
                return item.Entitlement.Weight
            })
            
            return weights.reduce((a, b) => a + b)
        },
        calculateTotalQuantity(ccrGroup){           
            let quantities = ccrGroup.map(item => {
                return item.Quantity
            })
            return quantities.reduce((a, b) => a + b)
        }
    },
});
